var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClinicsStage"},[_vm._v("\n  This is an Clinics page.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }